/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';

import { IAuth as Auth } from '../../models/auth';
import { IUserResponse } from '../../models/user';
import { Action, ActionType } from '../actionTypes/authActionTypes';
import { IPermission, IUserContractPermission } from '../../models/permission';


export interface IAuthState {
    authToken : string ,
    isPasswordChanged: boolean,
    user : IUserResponse | undefined | null;
    board: boolean;
    admin: boolean;
    userContractPermissions: IUserContractPermission[];
    permissions: IPermission[];
    failedLoginAttempts: number,
    loading: boolean;
    error? : string | null;
}

const initialState = {
    authToken : "" ,
    isPasswordChanged: false,
    user : null ,
    board: false,
    admin: false,
    userContractPermissions: [],
    permissions: [],
    failedLoginAttempts: 0,
    loading: false,
    error : null
}

export const AuthReducer: Reducer<IAuthState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.AUTH_START:
            return { ...state, loading: true };
        case ActionType.AUTH_SUCCESS:
            const auth: Auth = action.payload
            sessionStorage.setItem("token", auth.authToken);
            sessionStorage.setItem("user", JSON.stringify(auth.user));
            sessionStorage.setItem("userContractPermissions", JSON.stringify(auth.userContractPermissions));
            sessionStorage.setItem("permissions", 
                             auth.userContractPermissions.length === 1 && 
                             auth.userContractPermissions[0].projectid === null
                            ? JSON.stringify(auth.userContractPermissions[0].permissions)
                            : '[]')
            return {
                ...state,
                authToken : auth.authToken, 
                user : auth.user ,
                board: auth.userContractPermissions[0].board,
                admin: auth.userContractPermissions[0].admin,
                userContractPermissions : auth.userContractPermissions,
                permissions: auth.userContractPermissions.length === 1 && 
                             auth.userContractPermissions[0].projectid === null
                            ? auth.userContractPermissions[0].permissions 
                            : [],
                error : null , 
                loading: false
            };
        case ActionType.AUTH_FAIL:
            return {
                ...state,
                error: action.payload,
                failedLoginAttempts: state.failedLoginAttempts + 1,
                loading: false
            };
        case ActionType.CHANGEPASSWORD_ACTIVE:
            return {
                ...state,
                isPasswordChanged: action.payload,
            };
        case ActionType.SELECTPROJECT_SUCCESS:
            const contractid = action.payload.contractid;
            const userContractPermissions = action.payload.userContractPermissions;
            return {
                ...state,
                permissions: userContractPermissions.filter((x: IUserContractPermission) => x.projectid === contractid) &&
                             userContractPermissions.filter((x: IUserContractPermission) => x.projectid === contractid).length > 0 ? 
                             userContractPermissions.filter((x: IUserContractPermission) => x.projectid === contractid)[0].permissions : []
          
            };
        case ActionType.CHANGEPASSWORD_SUCCESS:
            return {
                ...state,
                isPasswordChanged: false,
            };
        case ActionType.LOGOUT:
            return {
                ...state,
                authToken : '' , 
                isPasswordChanged: false,
                user : null ,
                loading: false,
                error : null , 
            };
        case ActionType.REFRESH:
            const token = sessionStorage.getItem("token");
            const user = JSON.parse(sessionStorage.getItem("user")!);
            const permissions = JSON.parse(sessionStorage.getItem("permissions")!);
            const _userContractPermissions = JSON.parse(sessionStorage.getItem("userContractPermissions")!);

            // console.log('=========================================================')
            // console.log('token: ', token)
            // console.log('user: ', user)
            // console.log('permissions: ', permissions)
            console.log('userContractPermissions: ', _userContractPermissions)
            // console.log('=========================================================')
            
            return {
                ...state,
                authToken : token!, 
                permissions: permissions,
                userContractPermissions: _userContractPermissions,
                isPasswordChanged: false,
                user : user,
                board: _userContractPermissions && _userContractPermissions.length> 0 ?
                        _userContractPermissions[0].board : false,
                admin: _userContractPermissions && _userContractPermissions.length> 0 ?
                        _userContractPermissions[0].admin : false, 
                loading: false,
                error : null , 
            };        
        default:
            return state;
    }
};